var Option = function Option() {
  return null;
};

export default Option;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-mentions@0.4.0@rc-mentions/es/Option.js
// module id = 1344
// module chunks = 0